import { color } from 'highcharts'
import './LabelFooter.scss'

export default function LabelFooter(props: any) {
  const data = props?.data
  const listDefault = props?.listDefault || []
  
  const handleCickFilter = (value: string) => {
    props?.selectData(value)
  }

  return (
    <>
      <div className='CbxRzePmnh'>
        {
          data.map((item: any, key: number) => {
            return (
              <div className={`JlfWufYPaC`} key={key} onClick={() => handleCickFilter(item?.name)}>
                <div className='EQOnNFgQrj' style={listDefault.indexOf(item?.name) > -1 ? { backgroundColor: item?.color }
                  : { border: `1px solid ${item?.color}` }}></div>
                <div className='hqGhZYTsmX'>{item?.name}</div>
              </div>
            )
          })
        }
      </div>
    </>
  )
}